<kendo-grid [data]="factureDetails">
  <kendo-grid-column field="libelle" title="Libellé"></kendo-grid-column>
  <kendo-grid-column field="caMin" title="CA avant" format="{0:c}"></kendo-grid-column>
  <kendo-grid-column field="caMax" title="CA après" format="{0:c}"></kendo-grid-column>
  <kendo-grid-column field="fractionBaseCalculHt" title="Base" format="{0:c}"></kendo-grid-column>
  <kendo-grid-column field="taux" title="Taux" format="{0:p}"></kendo-grid-column>
  <kendo-grid-column field="ht" title="HT" format="{0:c}"></kendo-grid-column>
</kendo-grid>